import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const availabilityStatusTenantSettingsEntity: Entity = {
  model: model,
  repository: repository,
}

export default availabilityStatusTenantSettingsEntity
